import { useEffect } from "react";
import {MainTable} from "../../../Components/Macro/MainTable/MainTable";
import Add from "./Add";
import Edit from "./Edit";
import { useVideos } from "./VideoStore";

export const Videos = () => {
    let {videos, columns, setEd, delVideo, setVideo} = useVideos()
    useEffect(() => {
        setVideo()
    }, [])
    return (
        <>
            <MainTable
                pageTitle={'Videolar'}
                pcolumns={columns}
                pdata={videos}
                defkey={'id'}
                add={<Add />}
                setEd={setEd}
                edit={<Edit />}
                onEdit={(data) => {
                    setEd(data)
                }}
                onDelete={(_, id) => {
                    delVideo(id)
                }}
            />
        </>
    )
}